/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProviderFile } from './';
import {
    ProviderFileFromJSON,
    ProviderFileFromJSONTyped,
    ProviderFileToJSON,
} from './';
import type { ProviderValidationStatus } from './';
import {
    ProviderValidationStatusFromJSON,
    ProviderValidationStatusFromJSONTyped,
    ProviderValidationStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderFileData
 */
export interface ProviderFileData {
    /**
     * 
     * @type {string}
     * @memberof ProviderFileData
     */
    externalId: string;
    /**
     * 
     * @type {Array<ProviderFile>}
     * @memberof ProviderFileData
     */
    files: Array<ProviderFile>;
    /**
     * 
     * @type {string}
     * @memberof ProviderFileData
     */
    complianceFileId?: string;
    /**
     * 
     * @type {ProviderValidationStatus}
     * @memberof ProviderFileData
     */
    validationStatus: ProviderValidationStatus;
    /**
     * refusal reason if present.
     * @type {string}
     * @memberof ProviderFileData
     */
    refusalReason?: string;
    /**
     * Link to the document directly on the provider.
     * @type {string}
     * @memberof ProviderFileData
     */
    link: string;
    /**
     * Download links for the document versions sent to this provider.
     * @type {Array<string>}
     * @memberof ProviderFileData
     */
    downloadLinks: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof ProviderFileData
     */
    uploadDate?: Date;
}

/**
 * Check if a given object implements the ProviderFileData interface.
 */
export function instanceOfProviderFileData(value: object): value is ProviderFileData {
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('files' in value) || value['files'] === undefined) return false;
    if (!('validationStatus' in value) || value['validationStatus'] === undefined) return false;
    if (!('link' in value) || value['link'] === undefined) return false;
    if (!('downloadLinks' in value) || value['downloadLinks'] === undefined) return false;
    return true;
}

export function ProviderFileDataFromJSON(json: any): ProviderFileData {
    return ProviderFileDataFromJSONTyped(json, false);
}

export function ProviderFileDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderFileData {
    if (json == null) {
        return json;
    }
    return {
        
        'externalId': json['externalId'],
        'files': ((json['files'] as Array<any>).map(ProviderFileFromJSON)),
        'complianceFileId': json['complianceFileId'] == null ? undefined : json['complianceFileId'],
        'validationStatus': ProviderValidationStatusFromJSON(json['validationStatus']),
        'refusalReason': json['refusalReason'] == null ? undefined : json['refusalReason'],
        'link': json['link'],
        'downloadLinks': json['downloadLinks'],
        'uploadDate': json['uploadDate'] == null ? undefined : (new Date(json['uploadDate'])),
    };
}

export function ProviderFileDataToJSON(value?: ProviderFileData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'externalId': value['externalId'],
        'files': ((value['files'] as Array<any>).map((v) => ProviderFileToJSON(v))),
        'complianceFileId': value['complianceFileId'],
        'validationStatus': ProviderValidationStatusToJSON(value['validationStatus']),
        'refusalReason': value['refusalReason'],
        'link': value['link'],
        'downloadLinks': value['downloadLinks'],
        'uploadDate': value['uploadDate'] == null ? undefined : ((value['uploadDate']).toISOString()),
    };
}

